<div class="container">
  <div class="row justify-content-center area-item-name">
    {{ selectedAreaItemName }}
  </div>
  <div class="row justify-content-center">
    <div class="col-xs-12 col-lg-10 col-xl-8 ">
      <section>
        <div class="row">
          <div class="col-12 slots-diagram">
            <div>
              <section class="slots-diagram-header">
                <app-time-slot-date-selector (nextDayClick)="nextDayClick()" (prevDayClick)="prevDayClick()"
                  [selectedDate]="selectedDate" [calendarService]="bookingSlotStateService">
                </app-time-slot-date-selector>
              </section>
              <section class="mb-4">
                <div class="row justify-content-center">
                  <div class="col-12">
                    <app-slider #slider [min]="minPersonCount" [max]="maxPersonCount" [(ngModel)]="personCount">
                    </app-slider>
                  </div>
                </div>
              </section>
              <section *ngIf="showNoSlotMessage || maxPersonCount === personCount">
                <app-booking-contact-us [title]="'More persons' | translate: {maxPersonCount: personCount}" [description]="'No problem, contact us' | translate"></app-booking-contact-us>
              </section>
              <section>
                <app-time-slots-event class="row" [timeSlots]="displayTimeSlots"
                  (timeSlotSelected)="onClickTimeSlot($event)"></app-time-slots-event>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
